import { inAppMobile, inMgnl, isJelMobile } from '@/helpers/AppHelpers';
import { isProductSourceInQueryParams, ProductSourceInfo } from '@/helpers/ProductSourceHelpers';
import store from '@/store';

export default {
  // Wrapper ejApi.ouvrirSession pour retourner une Promise
  ouvrirSession(courriel, motDePasse) {
    return new Promise((resolve, reject) => {

      const self = this;

      const fctSucces = function () {
        // eslint-disable-next-line no-undef
        ejApi.ecrireCookie('autoexclusion', false);

        // eslint-disable-next-line no-undef
        ejApi.ecrireCookie('pausedejeu', false);

        self.ajouterCookieConnectionCompteEJ();

        // Pour avoir le profile et accéder à la page identite-reprise.
        store.commit('profile/RESET');

        resolve('done');
      };

      const fctEchec = function () {
        // eslint-disable-next-line no-undef
        ejConnect.ajouterFlagAutoExlu();

        // eslint-disable-next-line no-undef
        ejConnect.ajouterFlagEnPauseDeJeu();
        self.ajouterCookieConnectionCompteEJ();
        self.cleanUpSession();
        reject(new Error('CONNEXION'));
      };

      if (isJelMobile() && !inAppMobile()) {
        // eslint-disable-next-line no-undef
        ejConnect.ouvrirSessionAvecGeoloc(courriel, motDePasse, fctSucces, fctEchec);
      } else {
        // eslint-disable-next-line no-undef
        ejApi.ouvrirSession(courriel, motDePasse, fctSucces, fctEchec);
      }
    });
  },

  // Wrapper ejApi.fermerSession pour retourner une Promise
  fermerSession() {
    return new Promise((resolve, reject) => {
      const self = this;

      // eslint-disable-next-line no-undef
      ejApi.fermerSession(
        function () {
          self.cleanUpSession();
          self.deleteAllCookies();
          resolve('done');
        },

        function () {
          reject(new Error('DECONNEXION'));
        }
      );
    });
  },

  cleanUpSession() {
    clearStates();
    clearSessionStorage();
  },

  // Permet d'ajouter le cookie d'intention de login.
  ajouterCookieConnectionCompteEJ() {
    try {
      // eslint-disable-next-line no-undef
      ejConnect.addConnectionWCookie();
    } catch (error) {
      console.error("Erreur à l'ajout du cookie d'intention de login", error);
    }
  },

  sessionEstOuverte() {
    if (inMgnl) {
      return false;
    }
    // try/catch car possiblité que ejApi ne soit pas disponible
    try {
      // eslint-disable-next-line no-undef
      return ejApi.sessionEstOuverte() || ejApi.lireCookie('logged_in') == '1';
    } catch (error) {
      return false;
    }
  },

  // Delete all cookies
  deleteAllCookies() {
    const cookies = document.cookie.split(';');

    // eslint-disable-next-line no-restricted-syntax
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      // eslint-disable-next-line no-undef
      ejApi.supprimerCookie(name);
    }
  },

  /**
   * Obtenir le jeton iam
   * @returns
   */
  async getOauthAccessToken() {
    if (process.env.VUE_APP_IS_MOCK == 'true' || inMgnl) {
      return Promise.resolve('token-mock');
    }

    return new Promise((resolve, reject) => {
      if (isProductSourceInQueryParams(ProductSourceInfo.MA_MJ)) {
        this.getNativeBridgeAppClient().then((bridgeHandler) => {
          bridgeHandler
            .getAccessTokenFromNativeBridge()
            .then((token) => {
              resolve(token);
            })
            .catch((error) => {
              reject(error);
            });
        });
      } else {
        const silentRedirect = `${process.env.VUE_APP_IAM_DOMAIN}/oauth-redirect/ejd-silent`;
        this.getAuthClientWeb().then(function (oAuthClient) {
          oAuthClient
            .authorize({
              type: 'silent',
              scopes: ['ACCOUNT'],
              redirectUri: silentRedirect,
            })
            .then(
              function (result) {
                oAuthClient
                  .completeAuthorization({
                    state: result.state,
                    authorizationCode: result.code,
                    originalRedirectUri: silentRedirect,
                  })
                  .then(
                    function (completeResult) {
                      oAuthClient.accessToken.then(
                        function (token) {
                          resolve(token);
                        },
                        function (error) {
                          reject(error);
                        }
                      );
                    },
                    function (error) {
                      reject(error);
                    }
                  );
              },
              function (error) {
                reject(error);
              }
            );
        });
      }
    });
  },

  // Execute IAM session call after clearing IAM client auth paramaters from local storage.
  async getAuthClientWeb() {
    return new Promise((resolve, reject) => {
      const silentRedirect = `${process.env.VUE_APP_IAM_DOMAIN}/oauth-redirect/ejd-silent`;

      if (typeof __OpenbetIAMClient__ === 'undefined') {
        // Include IAM front-end SDK for session transfer logic.
        const iamscript = document.createElement('script');
        iamscript.type = 'text/javascript';
        iamscript.src = '/__ob/ob/js/iam-service.js';
        iamscript.onload = function () {
          // Create the iam client object.
          const authClient = getIamClient(silentRedirect);
          resolve(authClient);
        };
        document.head.appendChild(iamscript);
      } else {
        // Directly create the IAM Client since the SDK file is already loaded.
        // This is the ideal case due to perfomance concerns for asynchronous load at the above case.
        const authClient = getIamClient(silentRedirect);

        resolve(authClient);
      }
    });
  },

  // Chargement du sdk bridge pour le mobile App MOJP+.
  async getNativeBridgeAppClient() {
    return new Promise((resolve) => {
      if (typeof __OpenbetNativeBridge__ === 'undefined') {
        const bdgscript = document.createElement('script');
        bdgscript.type = 'text/javascript';
        bdgscript.src = '/__ob/ob/js/bridge-sdk.js';
        bdgscript.onload = function () {
          // Create the iam client object.
          // eslint-disable-next-line no-undef
          const bridgeHandler = new __OpenbetNativeBridge__({});
          resolve(bridgeHandler);
        };

        document.head.appendChild(bdgscript);
      } else {
        // eslint-disable-next-line no-undef
        const bridgeHandler = new __OpenbetNativeBridge__({});
        resolve(bridgeHandler);
      }
    });
  },
};

/**
 * Création du client oauth
 * @returns
 */
function getIamClient(silentRedirect) {
  return new window.__OpenbetIAMClient__({
    clientId: '9b261d3f-4cac-4628-b842-19545d09',
    endpoint: process.env.VUE_APP_IAM_DOMAIN,
    name: 'EJD',
    scopes: ['ACCOUNT'],
    silentRedirectUri: silentRedirect,
    silentAuthFrameType: 'iframe',
    silentAuthTimeout: '10000',
  });
}

function clearStates() {
  store.commit('compte/RESET');
  store.commit('profile/RESET');
  store.commit('dossier/RESET');
};

function clearSessionStorage() {
  sessionStorage.removeItem('@ce:compte');
  sessionStorage.removeItem('lq_client_uuid');
}